export default __webpack_public_path__ + "f7db60e64e54c76167706371c97f739c.png";